import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=c03aec12&"
import script from "./Domicilio.vue?vue&type=script&lang=js&"
export * from "./Domicilio.vue?vue&type=script&lang=js&"
import style0 from "./Domicilio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports